<template>
  <div class="CInware">
    <!-- 搜索框 -->
    <div class="searchBox">
      <el-input class="searchInput" placeholder="订单号" v-model="keyword.number" clearable @keyup.enter.native="InOutStorageList(1)"></el-input>
      <!-- <el-date-picker
        v-model="keyword.time"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="InOutStorageList(1)">
      </el-date-picker> -->
      <el-button class="searchBtn" type="primary" @click="InOutStorageList(1)">搜 索</el-button>
    </div>
    <!-- 添加信息 -->
    <!-- <div class="addButton">
      <el-button type="primary">导入</el-button>
    </div> -->

    <el-table v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="订单号" prop="Id"></el-table-column>
      <el-table-column label="制单人" prop="Creator"></el-table-column>
      <el-table-column label="业务类型">
        <template slot-scope="scope">
          <span v-if="scope.row.Type == 'LRB'">借还业务</span>
        </template>
      </el-table-column>
      <el-table-column label="入库时间" prop="Time"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="openDio('detail',scope.row)">查看</el-button>
          <!-- <el-button type="text">打印</el-button> -->
          <!-- <el-button type="text" @click="openDio('del',scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="paging" v-if="total>limits">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="limits"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="dioTitle" :visible.sync="InwareDio" :width="dioWidth" class="configDio wareDio" center>
      <div class="contDio">
        <div class="info">
          <span>订单号：{{dioform.Id}}</span>
          <span>制单人：{{dioform.Creator}}</span>
          <span>入库时间：{{dioform.Time}}</span>
        </div>
        <el-table :data="dioform.tabData" style="width: 100%">
          <el-table-column label="产品编号" prop="ProductId"></el-table-column>
          <el-table-column label="产品名称" prop="ProductName"></el-table-column>
          <el-table-column label="产品批号" prop="ProductNumber"></el-table-column>
          <el-table-column label="类别" prop="ProductType"></el-table-column>
          <el-table-column label="规格" prop="Spec"></el-table-column>
          <el-table-column label="供应商" prop="Supplier"></el-table-column>
          <el-table-column label="仓库" prop="Warehouse"></el-table-column>
          <el-table-column label="库位" prop="Storehouse"></el-table-column>
          <el-table-column label="货架" prop="Shelves"></el-table-column>
          <el-table-column label="货位" prop="Location"></el-table-column>
          <el-table-column label="入库数">
            <template slot-scope="scope">{{scope.row.Rfid.length}}</template>
          </el-table-column>
          <el-table-column label="单位" prop="Unit"></el-table-column>
          <el-table-column label="重量" prop="Weight"></el-table-column>
          <el-table-column label="生产日期" prop="Date"></el-table-column>
          <el-table-column label="有效期" prop="Validity"></el-table-column>
          <el-table-column label="RFID编号" prop="" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="openRfid(scope.row.Rfid)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot">
          <el-button @click="InwareDio = false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--RFID弹窗-->
    <el-dialog title="RFID" width="500px" :visible.sync="rfidDio" class="configDio">
      <el-table :data="rfidData" style="width:100%">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="RFID" prop="rfid"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="rfidDio = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from "../../../../../static/js/api.js"
  var vm
  export default {
    data(){
      return {
        //搜索
        keyword:{
          number:'',//订单号
          time:'',//入库时间
        },

        loading:false,//表格刷新
        tableData:[],//表格数据

        //分页
        curr:1,
        limits:10,
        total:0,

        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        InwareDio:false,//弹窗状态
        dioform:{
          Id:'',
          Creator:'',//制单人
          Time:'',//时间
          tabData:[],
        },

        rfidDio:false,//RFID弹窗
        rfidData:[],//RFID数据

      }
    },
    components: {
      CBreadCrumb,
    },
    async created(){
      vm = this
      this.InOutStorageList()
    },
    methods:{
      //打开RFID弹窗
      openRfid(info){
        const arr=[]
        for(var i in info){
          let obj = {
            rfid:info[i]
          }
          arr.push(obj)
        }
        this.rfidData = arr
        this.rfidDio = true
      },
      //打开弹窗
      openDio(type,info){
        if(type !='del'){
          this.dioType = type
          if(type == 'detail'){
            vm.dioform.Id = info.Id
            vm.dioform.Creator = info.Creator
            vm.dioform.Time = info.Time
            vm.dioform.tabData = info.Data
            console.log(info.Data)
            this.dioWidth="800px"
            this.dioTitle="入库单详情"
          }else if(type == 'import'){

          }
          this.InwareDio = true
        }else{
          vm.dioform.Id = info.Id
          this.$confirm('确定删除该订单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.UpdateInOutStorage()
          }).catch(() => {});
        }
      },

      //删除出入库订单
      async UpdateInOutStorage(){
        let data ={
          'OrderId': vm.dioform.Id,
          'Type':'1',//类型 1入库，2出库
        }
        const res = await bussinessApi.UpdateInOutStorage(data)
        if(res.ErrCode == 0){
          showToast('删除成功')
          vm.InOutStorageList(1)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //入库列表
      async InOutStorageList(curr,limits){
        this.loading = true
        const data = {
          // 'StartTime': vm.keyword.time ? vm.keyword.time[0]:'',//开始时间
          // 'EndTime': vm.keyword.time ? vm.keyword.time[1]:'',//结束时间
          'OrderId': vm.keyword.number,//订单号
          'Type':'1',//1入库，2出库
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits :vm.limits,
        }
        const res = await bussinessApi.InOutStorageList(data)
        this.loading = false
        if(res.ErrCode == 0){
          vm.tableData = res.Result.List
          vm.curr = parseInt(res.Result.Curr)
          vm.total = parseInt(res.Result.Total)
        }
      },

      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        this.InOutStorageList(val)
      },
    },
  }
</script>
<style lang="scss">
.CInware{
  padding: 24px;
  .w100{
    width: 100px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }
  .contDio{
    .info{
      span{
        margin-right: 30px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }
    .foot{
      text-align: right;
      margin-top: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/COutInWareManage/CInware.vue